export const menuItems = [
  {
    name: "Dashboard",
    path: "dashboard",
    icon: "dashboardicon.svg",
    activeIcon: "dashboardiconActive.svg",
    hoverIcon: "dashboardiconHover.svg",
  },
  {
    // Its own permission module (`plan_usage`, id 14 in the backend
    // MODULE_CATALOG), so it is grantable independently of Plans & Pricing.
    // The path is a sub-route of plans-pricing, which is why
    // isPathAllowedByModulePermissions special-cases it instead of falling
    // through to the first-segment rule.
    name: "Plan Usage",
    path: "plans-pricing/usage",
    icon: "planusageicon.svg",
    activeIcon: "planusageiconActive.svg",
    hoverIcon: "planusageiconHover.svg",
  },
  {
    name: "PostHog",
    path: "posthog",
    icon: "analyticsicon.svg",
    activeIcon: "analyticsiconActive.svg",
    hoverIcon: "analyticsiconHover.svg",
  },
  {
    name: "Zory Analytics",
    path: "zory-analytics",
    ssoUrl: "https://intelligence.zory.ai/api/auth/sso",
    icon: "zoryanalyticsicon.svg",
    activeIcon: "zoryanalyticsiconActive.svg",
    hoverIcon: "zoryanalyticsiconActive.svg",
  },
  {
    name: "Merchants",
    path: "merchants",
    icon: "businessInactive.svg",
    activeIcon: "businessicon.svg",
    hoverIcon: "businessicon.svg",
  },
  {
    name: "Stores",
    path: "stores",
    icon: "storesicon.svg",
    activeIcon: "storesiconActive.svg",
    hoverIcon: "storesiconHover.svg",
  },
  {
    name: "Products",
    path: "products",
    icon: "products.svg",
    activeIcon: "productsActive.svg",
    hoverIcon: "productsHover.svg",
  },
  {
    name: "Merchant Users",
    path: "users",
    icon: "usericon.svg",
    activeIcon: "usericonActive.svg",
    hoverIcon: "usericonHover.svg",
  },
  {
    name: "Admin roles",
    path: "create-roles",
    icon: "user-list-role.svg",
    activeIcon: "user-list-role-orange.svg",
    hoverIcon: "user-list-role-orange.svg",
  },
  {
    name: "Users",
    path: "all-users",
    icon: "usericon.svg",
    activeIcon: "usericonActive.svg",
    hoverIcon: "usericonHover.svg",
  },
  {
    name: "Campaigns",
    path: "campaigns",
    icon: "marketing.svg",
    activeIcon: "marketing-orange.svg",
    hoverIcon: "marketing-orange.svg",
  },
  {
    name: "Discounts",
    path: "discounts",
    icon: "discount-tag-black.svg",
    activeIcon: "discount-orange.svg",
    hoverIcon: "discount-orange.svg",
  },
  {
    name: "Plan and Pricing",
    path: "plans-pricing",
    icon: "plansicon.svg",
    activeIcon: "plansiconActive.svg",
    hoverIcon: "plansiconHover.svg",
  },
  {
    name: "Referrals",
    path: "referrals",
    icon: "link-forward.svg",
    activeIcon: "link-forward-active.svg",
    hoverIcon: "link-forward-active.svg",
  },
  {
    name: "Announcements",
    path: "announcements",
    icon: "announcement.svg",
    activeIcon: "announcementActive.svg",
    hoverIcon: "announcementHover.svg",
  },
  {
    name: "Library",
    path: "library",
    icon: "library-icon.svg",
    activeIcon: "library-icon-active.svg",
    hoverIcon: "library-icon-active.svg",
  },
  {
    name: "Categories",
    path: "categories",
    icon: "category_white.svg",
    activeIcon: "category_red.svg",
    hoverIcon: "category_red.svg",
  },
  {
    name: "Contacts",
    path: "contacts",
    icon: "usericon.svg",
    activeIcon: "usericonActive.svg",
    hoverIcon: "usericonHover.svg",
  },
  {
    // Backed by the `sales_requests` permission module (id 15) — grantable to
    // market roles from Create Roles, and superadmin-only otherwise.
    name: "Sales Requests",
    path: "sales-requests",
    icon: "usericon.svg",
    activeIcon: "usericonActive.svg",
    hoverIcon: "usericonHover.svg",
  },
  {
    // Backed by the `site_policies` permission module (id 16). Edits the
    // Privacy Policy and Terms and Conditions shown on the marketing site.
    name: "Policies & Privacy",
    path: "site-policies",
    icon: "policies.svg",
    activeIcon: "policiesActive.svg",
    hoverIcon: "policiesActive.svg",
  },
  {
    name: "Chatbot Checker",
    path: "chatbot-checker",
    icon: "chatboticon.svg",
    activeIcon: "chatboticonActive.svg",
    hoverIcon: "chatboticonHover.svg",
  },
]

/** Shown in merchant sidebar when GET /account/profile/ is_org_owner === true. */
export const organizationMenuItems = [
  {
    name: "Organization team",
    path: "organization",
    icon: "user-list-role.svg",
    activeIcon: "user-list-role-orange.svg",
    hoverIcon: "user-list-role-orange.svg",
  },
  {
    name: "Organization generations",
    path: "organization/generations",
    icon: "credits-icon.svg",
    activeIcon: "credits-icon.svg",
    hoverIcon: "credits-icon.svg",
  },
]

export const settingsItems = [
  // { name: "Plans", path: "/plans", icon: "plansicon.svg", activeIcon: "plansiconActive.svg", hoverIcon:"plansiconHover.svg" },
  {
    name: "Settings",
    path: "/setting",
    icon: "settingicon.svg",
    activeIcon: "settingiconActive.svg",
    hoverIcon: "settingiconActive.svg",
  },
]
export const productCategories = [
  { value: "chair", label_en: "Chair", label_ar: "كرسي" },
  {
    value: "2-seater-sofa",
    label_en: "2 Seater Sofa",
    label_ar: "كنبة بمقعدين",
  },
  {
    value: "3-seater-sofa",
    label_en: "3 Seater Sofa",
    label_ar: "كنبة بثلاثة مقاعد",
  },
  {
    value: "l-shape-sofa",
    label_en: "L Shape Sofa",
    label_ar: "كنبة على شكل L",
  },
  { value: "sofa", label_en: "Sofa", label_ar: "كنبة" },
  { value: "bed", label_en: "Bed", label_ar: "سرير" },
  { value: "bedspread", label_en: "Bedspread", label_ar: "مفرش سرير" },
  { value: "pillow", label_en: "Pillow", label_ar: "وسادة" },
  { value: "mattresses", label_en: "Mattresses", label_ar: "مراتب" },
  { value: "mattress-pad", label_en: "Mattress Pad", label_ar: "وسادة مرتبة" },
  { value: "service-table", label_en: "Service Table", label_ar: "طاولة خدمة" },
  { value: "center-table", label_en: "Center Table", label_ar: "طاولة وسط" },
  { value: "side-table", label_en: "Side Table", label_ar: "طاولة جانبية" },
  { value: "console", label_en: "Console", label_ar: "كونسول" },
  {
    value: "dressing-table",
    label_en: "Dressing Table",
    label_ar: "طاولة زينة",
  },
  { value: "comforter", label_en: "Comforter", label_ar: "لحاف" },
  { value: "tv-table", label_en: "TV Table", label_ar: "طاولة تلفاز" },
  { value: "dining-table", label_en: "Dining Table", label_ar: "طاولة طعام" },
  { value: "storage-box", label_en: "Storage Box", label_ar: "صندوق تخزين" },
  { value: "carpet", label_en: "Carpet", label_ar: "سجادة" },
  {
    value: "flower-pot-and-plant",
    label_en: "Flower Pot And Plant",
    label_ar: "أصيص وزرع",
  },
  {
    value: "statue-and-antique",
    label_en: "Statue And Antique",
    label_ar: "تماثيل وتحف",
  },
  { value: "laundry-basket", label_en: "Laundry Basket", label_ar: "سلة غسيل" },
  { value: "candle", label_en: "Candle", label_ar: "شمعة" },
  { value: "candlestick", label_en: "Candlestick", label_ar: "حامل شموع" },
  { value: "vase", label_en: "Vase", label_ar: "مزهرية" },
  { value: "flower", label_en: "Flower", label_ar: "زهرة" },
  { value: "wall-clock", label_en: "Wall Clock", label_ar: "ساعة حائط" },
  { value: "shelve", label_en: "Shelve", label_ar: "رف" },
  {
    value: "decorative-hanger",
    label_en: "Decorative Hanger",
    label_ar: "علاقة زينة",
  },
  { value: "lighting", label_en: "Lighting", label_ar: "إضاءة" },
  { value: "lampshade", label_en: "Lampshade", label_ar: "غطاء مصباح" },
  { value: "floor-stand", label_en: "Floor Stand", label_ar: "حامل أرضي" },
  {
    value: "wall-lighting",
    label_en: "Wall Lighting",
    label_ar: "إضاءة حائطية",
  },
  {
    value: "outdoor-lighting",
    label_en: "Outdoor Lighting",
    label_ar: "إضاءة خارجية",
  },
  { value: "chandelier", label_en: "Chandelier", label_ar: "ثريا" },
  {
    value: "pendant-lighting",
    label_en: "Pendant Lighting",
    label_ar: "إضاءة متدلية",
  },
  { value: "coffee-maker", label_en: "Coffee Maker", label_ar: "آلة قهوة" },
  {
    value: "cooking-appliance",
    label_en: "Cooking Appliance",
    label_ar: "أجهزة طهي",
  },
  {
    value: "food-processor",
    label_en: "Food Processor",
    label_ar: "محضر طعام",
  },
  { value: "cooking-pot", label_en: "Cooking Pot", label_ar: "قدر طهي" },
  {
    value: "serving-utensil-and-tray",
    label_en: "Serving Utensil And Tray",
    label_ar: "أدوات تقديم وصينية",
  },
  { value: "cup", label_en: "Cup", label_ar: "كوب" },
  { value: "plate", label_en: "Plate", label_ar: "طبق" },
  {
    value: "chaise-lounge",
    label_en: "Chaise Lounge",
    label_ar: "كرسي استرخاء",
  },
  { value: "art-canvas", label_en: "Art Canvas", label_ar: "لوحة فنية" },
  { value: "wardrobe", label_en: "Wardrobe", label_ar: "خزانة-الملابس" },
  {
    value: "weight-bench-flat",
    label_en: "Weight Bench Flat",
    label_ar: "مقعد رفع الأثقال",
  },
  {
    value: "weight-bench-adjustable",
    label_en: "Weight Bench Adjustable",
    label_ar: "مقعد رفع الأثقال قابل للتعديل",
  },
  { value: "stationary-bike", label_en: "Stationary Bike", label_ar: "دراجة ثابتة" },
  { value: "treadmill", label_en: "Treadmill", label_ar: "جهاز المشي" },
  { value: "dumbbell", label_en: "Dumbbell", label_ar: "أثقال" },
  {
    value: "elliptical-machine",
    label_en: "Elliptical Machine",
    label_ar: "جهاز المشي الهوائي",
  },
  { value: "kettlebells", label_en: "Kettlebells", label_ar: "كتيل بيل" },
  { value: "medicine-ball", label_en: "Medicine Ball", label_ar: "كرة طبية" },
  { value: "power-rack", label_en: "Power Rack", label_ar: "باور راك" },
  { value: "yoga-mat", label_en: "Yoga Mat", label_ar: "يوغا مات" },
  {
    value: "leg-press-machine",
    label_en: "Leg Press Machine",
    label_ar: "جهاز ضغط الأرجل",
  },
  {
    value: "chest-press-machine",
    label_en: "Chest Press Machine",
    label_ar: "جهاز ضغط الصدر",
  },
  { value: "jump-rope", label_en: "Jump Rope", label_ar: "حبل القفز" },
  { value: "air-bike", label_en: "Air Bike", label_ar: "دراجة هوائية" },
  { value: "barbell", label_en: "Barbell", label_ar: "بار حديدي" },
  {
    value: "boxing-gloves",
    label_en: "Boxing Gloves",
    label_ar: "قفازات ملاكمة",
  },
  {
    value: "weight-plates",
    label_en: "Weight Plates",
    label_ar: "أقراص أوزان",
  },
  { value: "office-table", label_en: "Office Table", label_ar: "طاولة مكتب" },
  { value: "office-chair", label_en: "Office Chair", label_ar: "كرسي مكتب" },
]

export const COUNTRIES = [
  // { value: "AF", label_en: "Afghanistan", label_ar: "أفغانستان" },
  // { value: "AX", label_en: "Åland Islands", label_ar: "جزر آلاند" },
  // { value: "AL", label_en: "Albania", label_ar: "ألبانيا" },
  // { value: "DZ", label_en: "Algeria", label_ar: "الجزائر" },
  // { value: "AS", label_en: "American Samoa", label_ar: "ساموا الأمريكية" },
  // { value: "AD", label_en: "Andorra", label_ar: "أندورا" },
  // { value: "AO", label_en: "Angola", label_ar: "أنغولا" },
  // { value: "AI", label_en: "Anguilla", label_ar: "أنغويلا" },
  // { value: "AQ", label_en: "Antarctica", label_ar: "أنتاركتيكا" },
  // { value: "AG", label_en: "Antigua and Barbuda", label_ar: "أنتيغوا وبربودا" },
  // { value: "AR", label_en: "Argentina", label_ar: "الأرجنتين" },
  // { value: "AM", label_en: "Armenia", label_ar: "أرمينيا" },
  // { value: "AW", label_en: "Aruba", label_ar: "أروبا" },
  // { value: "AU", label_en: "Australia", label_ar: "أستراليا" },
  // { value: "AT", label_en: "Austria", label_ar: "النمسا" },
  // { value: "AZ", label_en: "Azerbaijan", label_ar: "أذربيجان" },
  // { value: "BS", label_en: "Bahamas", label_ar: "جزر البهاما" },

  { value: "BH", label_en: "Bahrain", label_ar: "البحرين" },

  // { value: "BD", label_en: "Bangladesh", label_ar: "بنغلاديش" },
  // { value: "BB", label_en: "Barbados", label_ar: "بربادوس" },
  // { value: "BY", label_en: "Belarus", label_ar: "بيلاروس" },
  // { value: "BE", label_en: "Belgium", label_ar: "بلجيكا" },
  // { value: "BZ", label_en: "Belize", label_ar: "بليز" },
  // { value: "BJ", label_en: "Benin", label_ar: "بنين" },
  // { value: "BM", label_en: "Bermuda", label_ar: "برمودا" },
  // { value: "BT", label_en: "Bhutan", label_ar: "بوتان" },
  // { value: "BO", label_en: "Bolivia", label_ar: "بوليفيا" },
  // { value: "BQ", label_en: "Bonaire, Sint Eustatius and Saba", label_ar: "بونير وسانت يوستاتيوس وسابا" },
  // { value: "BA", label_en: "Bosnia and Herzegovina", label_ar: "البوسنة والهرسك" },
  // { value: "BW", label_en: "Botswana", label_ar: "بوتسوانا" },
  // { value: "BV", label_en: "Bouvet Island", label_ar: "جزيرة بوفيت" },
  // { value: "BR", label_en: "Brazil", label_ar: "البرازيل" },
  // { value: "IO", label_en: "British Indian Ocean Territory", label_ar: "إقليم المحيط الهندي البريطاني" },
  // { value: "BN", label_en: "Brunei", label_ar: "بروناي" },
  // { value: "BG", label_en: "Bulgaria", label_ar: "بلغاريا" },
  // { value: "BF", label_en: "Burkina Faso", label_ar: "بوركينا فاسو" },
  // { value: "BI", label_en: "Burundi", label_ar: "بوروندي" },
  // { value: "CV", label_en: "Cabo Verde", label_ar: "الرأس الأخضر" },
  // { value: "KH", label_en: "Cambodia", label_ar: "كمبوديا" },
  // { value: "CM", label_en: "Cameroon", label_ar: "الكاميرون" },
  // { value: "CA", label_en: "Canada", label_ar: "كندا" },
  // { value: "KY", label_en: "Cayman Islands", label_ar: "جزر كايمان" },
  // { value: "CF", label_en: "Central African Republic", label_ar: "جمهورية أفريقيا الوسطى" },
  // { value: "TD", label_en: "Chad", label_ar: "تشاد" },
  // { value: "CL", label_en: "Chile", label_ar: "تشيلي" },
  // { value: "CN", label_en: "China", label_ar: "الصين" },
  // { value: "CX", label_en: "Christmas Island", label_ar: "جزيرة كريسماس" },
  // { value: "CC", label_en: "Cocos (Keeling) Islands", label_ar: "جزر كوكوس (كيلينغ)" },
  // { value: "CO", label_en: "Colombia", label_ar: "كولومبيا" },
  // { value: "KM", label_en: "Comoros", label_ar: "جزر القمر" },
  // { value: "CG", label_en: "Congo", label_ar: "الكونغو" },
  // { value: "CD", label_en: "Congo (the Democratic Republic of the)", label_ar: "جمهورية الكونغو الديمقراطية" },
  // { value: "CK", label_en: "Cook Islands", label_ar: "جزر كوك" },
  // { value: "CR", label_en: "Costa Rica", label_ar: "كوستاريكا" },
  // { value: "CI", label_en: "Côte d'Ivoire", label_ar: "كوت ديفوار" },
  // { value: "HR", label_en: "Croatia", label_ar: "كرواتيا" },
  // { value: "CU", label_en: "Cuba", label_ar: "كوبا" },
  // { value: "CW", label_en: "Curaçao", label_ar: "كوراساو" },
  // { value: "CY", label_en: "Cyprus", label_ar: "قبرص" },
  // { value: "CZ", label_en: "Czechia", label_ar: "التشيك" },
  // { value: "DK", label_en: "Denmark", label_ar: "الدنمارك" },
  // { value: "DJ", label_en: "Djibouti", label_ar: "جيبوتي" },
  // { value: "DM", label_en: "Dominica", label_ar: "دومينيكا" },
  // { value: "DO", label_en: "Dominican Republic", label_ar: "جمهورية الدومينيكان" },
  // { value: "EC", label_en: "Ecuador", label_ar: "الإكوادور" },

  { value: "EG", label_en: "Egypt", label_ar: "مصر" },

  // { value: "SV", label_en: "El Salvador", label_ar: "السلفادور" },
  // { value: "GQ", label_en: "Equatorial Guinea", label_ar: "غينيا الاستوائية" },
  // { value: "ER", label_en: "Eritrea", label_ar: "إريتريا" },
  // { value: "EE", label_en: "Estonia", label_ar: "إستونيا" },
  // { value: "SZ", label_en: "Eswatini", label_ar: "إسواتيني" },
  // { value: "ET", label_en: "Ethiopia", label_ar: "إثيوبيا" },
  // { value: "FK", label_en: "Falkland Islands (Malvinas)", label_ar: "جزر فوكلاند (مالفيناس)" },
  // { value: "FO", label_en: "Faroe Islands", label_ar: "جزر فارو" },
  // { value: "FJ", label_en: "Fiji", label_ar: "فيجي" },
  // { value: "FI", label_en: "Finland", label_ar: "فنلندا" },
  // { value: "FR", label_en: "France", label_ar: "فرنسا" },
  // { value: "GF", label_en: "French Guiana", label_ar: "غويانا الفرنسية" },
  // { value: "PF", label_en: "French Polynesia", label_ar: "بولينيزيا الفرنسية" },
  // { value: "TF", label_en: "French Southern Territories", label_ar: "الأقاليم الجنوبية الفرنسية" },
  // { value: "GA", label_en: "Gabon", label_ar: "الغابون" },
  // { value: "GM", label_en: "Gambia", label_ar: "غامبيا" },
  // { value: "GE", label_en: "Georgia", label_ar: "جورجيا" },
  // { value: "DE", label_en: "Germany", label_ar: "ألمانيا" },
  // { value: "GH", label_en: "Ghana", label_ar: "غانا" },
  // { value: "GI", label_en: "Gibraltar", label_ar: "جبل طارق" },
  // { value: "GR", label_en: "Greece", label_ar: "اليونان" },
  // { value: "GL", label_en: "Greenland", label_ar: "غرينلاند" },
  // { value: "GD", label_en: "Grenada", label_ar: "غرينادا" },
  // { value: "GP", label_en: "Guadeloupe", label_ar: "غوادلوب" },
  // { value: "GU", label_en: "Guam", label_ar: "غوام" },
  // { value: "GT", label_en: "Guatemala", label_ar: "غواتيمالا" },
  // { value: "GG", label_en: "Guernsey", label_ar: "غيرنزي" },
  // { value: "GN", label_en: "Guinea", label_ar: "غينيا" },
  // { value: "GW", label_en: "Guinea-Bissau", label_ar: "غينيا بيساو" },
  // { value: "GY", label_en: "Guyana", label_ar: "غيانا" },
  // { value: "HT", label_en: "Haiti", label_ar: "هايتي" },
  // { value: "HM", label_en: "Heard Island and McDonald Islands", label_ar: "جزيرة هيرد وجزر ماكدونالد" },
  // { value: "VA", label_en: "Holy See", label_ar: "الكرسي الرسولي" },
  // { value: "HN", label_en: "Honduras", label_ar: "هندوراس" },
  // { value: "HK", label_en: "Hong Kong", label_ar: "هونغ كونغ" },
  // { value: "HU", label_en: "Hungary", label_ar: "المجر" },
  // { value: "IS", label_en: "Iceland", label_ar: "آيسلندا" },
  // { value: "IN", label_en: "India", label_ar: "الهند" },
  // { value: "ID", label_en: "Indonesia", label_ar: "إندونيسيا" },
  // { value: "IR", label_en: "Iran", label_ar: "إيران" },
  // { value: "IQ", label_en: "Iraq", label_ar: "العراق" },
  // { value: "IE", label_en: "Ireland", label_ar: "أيرلندا" },
  // { value: "IM", label_en: "Isle of Man", label_ar: "جزيرة مان" },
  // { value: "IL", label_en: "Israel", label_ar: "إسرائيل" },
  // { value: "IT", label_en: "Italy", label_ar: "إيطاليا" },
  // { value: "JM", label_en: "Jamaica", label_ar: "جامايكا" },
  // { value: "JP", label_en: "Japan", label_ar: "اليابان" },
  // { value: "JE", label_en: "Jersey", label_ar: "جيرزي" },
  // { value: "JO", label_en: "Jordan", label_ar: "الأردن" },
  // { value: "KZ", label_en: "Kazakhstan", label_ar: "كازاخستان" },
  // { value: "KE", label_en: "Kenya", label_ar: "كينيا" },
  // { value: "KI", label_en: "Kiribati", label_ar: "كيريباتي" },

  { value: "KW", label_en: "Kuwait", label_ar: "الكويت" },

  // { value: "KG", label_en: "Kyrgyzstan", label_ar: "قيرغيزستان" },
  // { value: "LA", label_en: "Laos", label_ar: "لاوس" },
  // { value: "LV", label_en: "Latvia", label_ar: "لاتفيا" },
  // { value: "LB", label_en: "Lebanon", label_ar: "لبنان" },
  // { value: "LS", label_en: "Lesotho", label_ar: "ليسوتو" },
  // { value: "LR", label_en: "Liberia", label_ar: "ليبيريا" },
  // { value: "LY", label_en: "Libya", label_ar: "ليبيا" },
  // { value: "LI", label_en: "Liechtenstein", label_ar: "ليختنشتاين" },
  // { value: "LT", label_en: "Lithuania", label_ar: "ليتوانيا" },
  // { value: "LU", label_en: "Luxembourg", label_ar: "لوكسمبورغ" },
  // { value: "MO", label_en: "Macao", label_ar: "ماكاو" },
  // { value: "MG", label_en: "Madagascar", label_ar: "مدغشقر" },
  // { value: "MW", label_en: "Malawi", label_ar: "ملاوي" },
  // { value: "MY", label_en: "Malaysia", label_ar: "ماليزيا" },
  // { value: "MV", label_en: "Maldives", label_ar: "جزر المالديف" },
  // { value: "ML", label_en: "Mali", label_ar: "مالي" },
  // { value: "MT", label_en: "Malta", label_ar: "مالطا" },
  // { value: "MH", label_en: "Marshall Islands", label_ar: "جزر مارشال" },
  // { value: "MQ", label_en: "Martinique", label_ar: "مارتينيك" },
  // { value: "MR", label_en: "Mauritania", label_ar: "موريتانيا" },
  // { value: "MU", label_en: "Mauritius", label_ar: "موريشيوس" },
  // { value: "YT", label_en: "Mayotte", label_ar: "مايوت" },
  // { value: "MX", label_en: "Mexico", label_ar: "المكسيك" },
  // { value: "FM", label_en: "Micronesia", label_ar: "ميكرونيزيا" },
  // { value: "MD", label_en: "Moldova", label_ar: "مولدوفا" },
  // { value: "MC", label_en: "Monaco", label_ar: "موناكو" },
  // { value: "MN", label_en: "Mongolia", label_ar: "منغوليا" },
  // { value: "ME", label_en: "Montenegro", label_ar: "الجبل الأسود" },
  // { value: "MS", label_en: "Montserrat", label_ar: "مونتسرات" },
  // { value: "MA", label_en: "Morocco", label_ar: "المغرب" },
  // { value: "MZ", label_en: "Mozambique", label_ar: "موزمبيق" },
  // { value: "MM", label_en: "Myanmar", label_ar: "ميانمار" },
  // { value: "NA", label_en: "Namibia", label_ar: "ناميبيا" },
  // { value: "NR", label_en: "Nauru", label_ar: "ناورو" },
  // { value: "NP", label_en: "Nepal", label_ar: "نيبال" },
  // { value: "NL", label_en: "Netherlands", label_ar: "هولندا" },
  // { value: "NC", label_en: "New Caledonia", label_ar: "كاليدونيا الجديدة" },
  // { value: "NZ", label_en: "New Zealand", label_ar: "نيوزيلندا" },
  // { value: "NI", label_en: "Nicaragua", label_ar: "نيكاراغوا" },
  // { value: "NE", label_en: "Niger", label_ar: "النيجر" },
  // { value: "NG", label_en: "Nigeria", label_ar: "نيجيريا" },
  // { value: "NU", label_en: "Niue", label_ar: "نيوي" },
  // { value: "NF", label_en: "Norfolk Island", label_ar: "جزيرة نورفولك" },
  // { value: "KP", label_en: "North Korea", label_ar: "كوريا الشمالية" },
  // { value: "MK", label_en: "North Macedonia", label_ar: "مقدونيا الشمالية" },
  // { value: "MP", label_en: "Northern Mariana Islands", label_ar: "جزر ماريانا الشمالية" },
  // { value: "NO", label_en: "Norway", label_ar: "النرويج" },

  { value: "OM", label_en: "Oman", label_ar: "عُمان" },

  // { value: "PK", label_en: "Pakistan", label_ar: "باكستان" },
  // { value: "PW", label_en: "Palau", label_ar: "بالاو" },
  // { value: "PS", label_en: "Palestine, State of", label_ar: "دولة فلسطين" },
  // { value: "PA", label_en: "Panama", label_ar: "بنما" },
  // { value: "PG", label_en: "Papua New Guinea", label_ar: "بابوا غينيا الجديدة" },
  // { value: "PY", label_en: "Paraguay", label_ar: "باراغواي" },
  // { value: "PE", label_en: "Peru", label_ar: "بيرو" },
  // { value: "PH", label_en: "Philippines", label_ar: "الفلبين" },
  // { value: "PN", label_en: "Pitcairn", label_ar: "بيتكيرن" },
  // { value: "PL", label_en: "Poland", label_ar: "بولندا" },
  // { value: "PT", label_en: "Portugal", label_ar: "البرتغال" },
  // { value: "PR", label_en: "Puerto Rico", label_ar: "بورتوريكو" },

  { value: "QA", label_en: "Qatar", label_ar: "قطر" },

  // { value: "RE", label_en: "Réunion", label_ar: "ريونيون" },
  // { value: "RO", label_en: "Romania", label_ar: "رومانيا" },
  // { value: "RU", label_en: "Russia", label_ar: "روسيا" },
  // { value: "RW", label_en: "Rwanda", label_ar: "رواندا" },
  // { value: "BL", label_en: "Saint Barthélemy", label_ar: "سان بارتيليمي" },
  // { value: "SH", label_en: "Saint Helena, Ascension and Tristan da Cunha", label_ar: "سانت هيلينا وأسينشين وتريستان دا كونا" },
  // { value: "KN", label_en: "Saint Kitts and Nevis", label_ar: "سانت كيتس ونيفيس" },
  // { value: "LC", label_en: "Saint Lucia", label_ar: "سانت لوسيا" },
  // { value: "MF", label_en: "Saint Martin (French part)", label_ar: "سان مارتن (الجزء الفرنسي)" },
  // { value: "PM", label_en: "Saint Pierre and Miquelon", label_ar: "سان بيير وميكلون" },
  // { value: "VC", label_en: "Saint Vincent and the Grenadines", label_ar: "سانت فنسنت وجزر غرينادين" },
  // { value: "WS", label_en: "Samoa", label_ar: "ساموا" },
  // { value: "SM", label_en: "San Marino", label_ar: "سان مارينو" },
  // { value: "ST", label_en: "Sao Tome and Principe", label_ar: "ساو تومي وبرينسيبي" },

  {
    value: "SA",
    label_en: "Saudi Arabia",
    label_ar: "المملكة العربية السعودية",
  },

  // { value: "SN", label_en: "Senegal", label_ar: "السنغال" },
  // { value: "RS", label_en: "Serbia", label_ar: "صربيا" },
  // { value: "SC", label_en: "Seychelles", label_ar: "سيشيل" },
  // { value: "SL", label_en: "Sierra Leone", label_ar: "سيراليون" },
  // { value: "SG", label_en: "Singapore", label_ar: "سنغافورة" },
  // { value: "SX", label_en: "Sint Maarten (Dutch part)", label_ar: "سينت مارتن (الجزء الهولندي)" },
  // { value: "SK", label_en: "Slovakia", label_ar: "سلوفاكيا" },
  // { value: "SI", label_en: "Slovenia", label_ar: "سلوفينيا" },
  // { value: "SB", label_en: "Solomon Islands", label_ar: "جزر سليمان" },
  // { value: "SO", label_en: "Somalia", label_ar: "الصومال" },
  // { value: "ZA", label_en: "South Africa", label_ar: "جنوب أفريقيا" },
  // { value: "GS", label_en: "South Georgia and the South Sandwich Islands", label_ar: "جورجيا الجنوبية وجزر ساندويتش الجنوبية" },
  // { value: "KR", label_en: "South Korea", label_ar: "كوريا الجنوبية" },
  // { value: "SS", label_en: "South Sudan", label_ar: "جنوب السودان" },
  // { value: "ES", label_en: "Spain", label_ar: "إسبانيا" },
  // { value: "LK", label_en: "Sri Lanka", label_ar: "سريلانكا" },
  // { value: "SD", label_en: "Sudan", label_ar: "السودان" },
  // { value: "SR", label_en: "Suriname", label_ar: "سورينام" },
  // { value: "SJ", label_en: "Svalbard and Jan Mayen", label_ar: "سفالبارد ويان ماين" },
  // { value: "SE", label_en: "Sweden", label_ar: "السويد" },
  // { value: "CH", label_en: "Switzerland", label_ar: "سويسرا" },
  // { value: "SY", label_en: "Syria", label_ar: "سوريا" },
  // { value: "TW", label_en: "Taiwan", label_ar: "تايوان" },
  // { value: "TJ", label_en: "Tajikistan", label_ar: "طاجيكستان" },
  // { value: "TZ", label_en: "Tanzania", label_ar: "تنزانيا" },
  // { value: "TH", label_en: "Thailand", label_ar: "تايلاند" },
  // { value: "TL", label_en: "Timor-Leste", label_ar: "تيمور-ليشتي" },
  // { value: "TG", label_en: "Togo", label_ar: "توغو" },
  // { value: "TK", label_en: "Tokelau", label_ar: "توكيلاو" },
  // { value: "TO", label_en: "Tonga", label_ar: "تونغا" },
  // { value: "TT", label_en: "Trinidad and Tobago", label_ar: "ترينيداد وتوباغو" },
  // { value: "TN", label_en: "Tunisia", label_ar: "تونس" },
  // { value: "TR", label_en: "Türkiye", label_ar: "تركيا" },
  // { value: "TM", label_en: "Turkmenistan", label_ar: "تركمانستان" },
  // { value: "TC", label_en: "Turks and Caicos Islands", label_ar: "جزر تركس وكايكوس" },
  // { value: "TV", label_en: "Tuvalu", label_ar: "توفالو" },
  // { value: "UG", label_en: "Uganda", label_ar: "أوغندا" },
  // { value: "UA", label_en: "Ukraine", label_ar: "أوكرانيا" },

  {
    value: "AE",
    label_en: "United Arab Emirates",
    label_ar: "الإمارات العربية المتحدة",
  },

  // { value: "GB", label_en: "United Kingdom", label_ar: "المملكة المتحدة" },
  // { value: "UM", label_en: "United States Minor Outlying Islands", label_ar: "جزر الولايات المتحدة البعيدة الصغيرة" },
  // { value: "US", label_en: "United States of America", label_ar: "الولايات المتحدة الأمريكية" },
  // { value: "UY", label_en: "Uruguay", label_ar: "أوروغواي" },
  // { value: "UZ", label_en: "Uzbekistan", label_ar: "أوزبكستان" },
  // { value: "VU", label_en: "Vanuatu", label_ar: "فانواتو" },
  // { value: "VE", label_en: "Venezuela", label_ar: "فنزويلا" },
  // { value: "VN", label_en: "Vietnam", label_ar: "فيتنام" },
  // { value: "VG", label_en: "Virgin Islands (British)", label_ar: "جزر العذراء البريطانية" },
  // { value: "VI", label_en: "Virgin Islands (U.S.)", label_ar: "جزر العذراء الأمريكية" },
  // { value: "WF", label_en: "Wallis and Futuna", label_ar: "واليس وفوتونا" },
  // { value: "EH", label_en: "Western Sahara", label_ar: "الصحراء الغربية" },
  // { value: "YE", label_en: "Yemen", label_ar: "اليمن" },
  // { value: "ZM", label_en: "Zambia", label_ar: "زامبيا" },
  // { value: "ZW", label_en: "Zimbabwe", label_ar: "زيمبابوي" }
]
